import { CommonModule, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { email } from '@rxweb/reactive-form-validators';
import { ApiService } from 'app/providers/api.service';

declare let Razorpay: any;

export interface DialogData {
  pymnt_dtls: string;
}

//   amount: 500000,
//   paymnet_hdr_name: 'Dreamstep',
//   description: 'Test Tranction', // optional
//   email: 'veeranageswararao.sivakoti@dreamstep.in',
//   contact: '9515302024',
//   bnfcry_name: 'Svn rao',
//   trn_type_id: 1,
//   ln_id: 1525211,
//   bnfcy_id: 156221  


@Component({
  selector: 'app-hdfc-payment-gateway',
  templateUrl: './hdfc-payment-gateway.component.html',
  styleUrls: ['./hdfc-payment-gateway.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, FormsModule, ReactiveFormsModule],
})
export class HdfcPaymentGatewayComponent implements OnInit {

  pymntDtls: any = {};
  data: any = {
    orderDetails: [],
    result: []
  }
  shwLdg = true
  paymentInProgress = false;
  _chechOutDetail: any = {
    key_id: '',
    razorpay_order_id: '',
    amount: '',
    name: '',
    description: '',
    email: '',
    contact: '',
    bnfcry_name: '',
    callback_url: '',
  }
  DialogData: any;
  today: string;
  // ={
  //   trn_id:'',
  //   ln_id:'',
  //   bnfcy_id:''
  // }
  constructor(public dialogRef: MatDialogRef<HdfcPaymentGatewayComponent>,
    @Inject(MAT_DIALOG_DATA) public _DialogData: DialogData,
    private apiSrvc: ApiService, private datePipe: DatePipe, private cdf: ChangeDetectorRef) {
    this.today = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

    //need fix issue in NgOnint
    this.DialogData = this._DialogData.pymnt_dtls;
    this.createOrder();

  }
  ngOnInit(): void {

    console.log("===================Changes Detection====================");
    // this.DialogData = this._DialogData.pymnt_dtls;
    console.log(this._DialogData, this.DialogData);
    // this.createOrder();
  }



  cancleDcVwr() {
    this.dialogRef.close();
  }
  createOrder = () => {
    this.shwLdg = true;
    const _postdata = {
      bnfcy_id: this.DialogData.bnfcy_id,
      trn_id: this.DialogData.trn_id,
      ln_id: this.DialogData.ln_id,
      hndlr_tx: this.DialogData.paymnet_hdr_name,
      tckt_id: this.DialogData.tckt_id,
    }

    this.apiSrvc.post(_postdata, 'payment/create/order').subscribe({
      next: (res) => {
        console.log(res)
        this.shwLdg = false;
        if (res['status'] == 200) {
          this.data.orderDetails = res[`data`];
          this.data.result = res[`data`][0]?.reqBody;

          console.log('hdfc payment res', this.data.result);
          if (this.cdf) {
            this.cdf.detectChanges();
          }
          this.dsblLdr()
        }
        else {
        }
      }, error: (error) => {
      }
    })



  }

  sbmtPay() {
    if (this.paymentInProgress) return; // Prevent multiple clicks
    this.paymentInProgress = true;
    this.shwLdg = true; // Show loader when starting payment
    if (this.data.orderDetails && this.data.orderDetails.length > 0) {
      let options: any = {
        key: this.data.orderDetails[0].key_id,
        amount: this.data.orderDetails[0].amount,
        currency: 'INR',
        name: this.pymntDtls.name ? this.pymntDtls.name : 'Dreamstep',
        order_id: this.data.orderDetails[0].id,
        callback_url: this.data.orderDetails[0].callback_url,
        prefill: {
          email: this.pymntDtls.email ? this.pymntDtls.email : this.data.result.email,
          contact: this.pymntDtls.contact ? this.pymntDtls.contact : this.data.result.contact,
        },
        cancel_url: this.data.orderDetails[0].clbk_cncl_url_tx,
        handler: (response: any) => {
          console.log("PAYMENT RESPONSE", response);
          try {
            console.log("Starting API call...");
            // Handle successful payment
            const paymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              receipt_no: this.data.orderDetails[0].receipt_no
            };
            
            console.log("Sending payment data:", paymentData);
            this.apiSrvc.post(paymentData, 'payment/checkout/order').subscribe({
              next: (verify_res: VerifyResponse) => {
                console.log('verify_res received:', verify_res);
                try {
                  if (verify_res && verify_res.status == 200) {
                    console.log("Payment verified successfully");
                    this.apiSrvc.shwAlrtMsg('success', 'Payment Status!', 'Payment successful!.', 3000);
                    this.shwLdg = false; // Hide loader before closing dialog
                    this.dialogRef.close(response);
                    
                    if (verify_res.data && verify_res.data.redirect_url) {
                      console.log("Redirecting to:", verify_res.data.redirect_url);
                      window.open(verify_res.data.redirect_url, '_blank');
                    }
                  } else {
                    this.shwLdg = false; // Hide loader on failure
                    console.error("Payment verification failed", verify_res);
                    this.apiSrvc.shwAlrtMsg('error', 'Payment Status!', 'Payment verification failed. Please try again.', 3000);
                  }
                } catch (err) {
                  this.shwLdg = false; // Hide loader on error
                  console.error("Error processing payment response:", err);
                  this.apiSrvc.shwAlrtMsg('error', 'Payment Status!', 'Error processing payment', 3000);
                }
              },
              error: (error) => {
                this.shwLdg = false; // Hide loader on API error
                this.paymentInProgress = false; // Reset on error
                console.error("Payment checkout API error:", error);
                this.apiSrvc.shwAlrtMsg('error', 'Payment Status!', 'Error during payment checkout. Please try again.', 3000);
              }
            });
          } catch (error) {
            this.shwLdg = false; // Hide loader on error
            this.paymentInProgress = false; // Reset on error
            console.error("Error in payment processing:", error);
            this.apiSrvc.shwAlrtMsg('error', 'Payment Status!', 'Error processing payment. Please contact support.', 3000);
          }
        }
      };

      this.pymntDtls.description ? options[`description`] = this.pymntDtls.description : '';
      this.pymntDtls.bnfcry_name ? options[`prefill`]['name'] = this.pymntDtls.bnfcry_name : '';
      this.pymntDtls.email ? options[`prefill`][`email`] = this.pymntDtls.email : '';
      this.pymntDtls.contact ? options[`prefill`][`contact`] = this.pymntDtls.contact : '';

      console.log(options, "=============")
      const rzp = new Razorpay(options);
      rzp.open();
    }
  }



  onPayentCancel(): void {

    this.dialogRef.close


  }


  dsblLdr() {
    let ldr = document.getElementById('dv_pymnt_ldr');
    if (ldr) {
      ldr['style']['display'] = 'none';
    }
  }

}

interface VerifyResponse {
  data?: {
    redirect_url?: string;
  };
  status?: number;
}